module.exports = __webpack_public_path__ + "media/images/sites/health/favicon-72x72-040400b2137801612045af5424c24b5e.png";